import { Skeleton, Table, TableBody, TableCell, TableContainer, TableRow } from "@mui/material";
import { withStyles } from "@mui/styles";

function TableSkeleton() {
  const StyledTableCell = withStyles((theme) => ({
    body: {
      borderColor: theme.palette.common.white,
      height: 60,
    },
  }))(TableCell);

  const StyledTableRow = withStyles((theme) => ({
    root: {
      "&:nth-of-type(odd)": {
        backgroundColor: theme.palette.action.hover,
      },
    },
  }))(TableRow);

  return (
    <TableContainer>
      <Table>
        <TableBody>
          {Array(6)
            .fill("")
            .map((item, index) => (
              <StyledTableRow key={item + index}>
                <StyledTableCell>
                  <Skeleton />
                </StyledTableCell>
                <StyledTableCell>
                  <Skeleton />
                </StyledTableCell>
                <StyledTableCell>
                  <Skeleton />
                </StyledTableCell>
              </StyledTableRow>
            ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default TableSkeleton;
